import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import { OutsideClickHandler } from 'components/atoms/outside-click-handler';
import { TemplateAssigneePicker } from 'components/molecules/assignee-picker/template-assignee-picker';
import { ProjectTemplateTask } from 'data/templates/projects';
import { useAssigneeChangeForTemplate } from 'data/templates/projects/hooks/use-assignee-change';
import { CellRendererParams } from '../../types';

const AssigneeWrapper = styled.div`
  padding: 0;

  & .ozone-select__control {
    outline-offset: -2px;
  }
`;
const OutsideClickWrapper = styled(OutsideClickHandler)`
  display: flex;
  flex: 1;
`;

export const AssigneeEditor = forwardRef<unknown, CellRendererParams>(
  (props, ref) => {
    const data = props.data.data as unknown as ProjectTemplateTask;
    const { type } = props.data;

    const { assignee } = data;

    const [value, setValue] = useState(assignee);

    useImperativeHandle(ref, () => {
      return {
        getValue: () => {
          return value;
        },
        isPopup: () => true,
        getPopupPosition: () => 'over',
      };
    });

    const popoverRef = useRef(null);

    const { onAssigneeChange, responsibleTeam, onPlaceholderCreate } =
      useAssigneeChangeForTemplate(data);

    const _onChange = (selected) => {
      const newAssignee = onAssigneeChange(selected);

      setValue(newAssignee);
      props.api.stopEditing();
      props.api.setFocusedCell(props.node.rowIndex, props.column);
    };

    if (!props.data.title || type !== 'TASK') {
      return null;
    }
    const columnWidth = props.column.getActualWidth();

    return (
      <OutsideClickWrapper
        data={{
          column_width: columnWidth.toString(),
          width: columnWidth.toString(),
          field_type: type,
        }}
        width={columnWidth}
        disabled
      >
        <AssigneeWrapper ref={popoverRef}>
          <TemplateAssigneePicker
            responsibleTeam={responsibleTeam}
            value={value}
            onDone={_onChange}
            placement="bottom"
            hideTrigger
            containerRef={popoverRef}
            onPlaceholderCreate={onPlaceholderCreate}
          />
        </AssigneeWrapper>
      </OutsideClickWrapper>
    );
  },
);
